<template>
    <v-card outlined elevation="1">
        <v-card-text class="pa-3" style="width: 100%">
            <div class="d-flex align-center flex-wrap justify-space-between flex-grow-1" style="width: 100%">
                <div class="d-flex align-center">
                    <div>
                        <v-chip 
                            :color="is_active ? 'primary' : 'secondary'" 
                            label 
                            class="font-weight-bold d-flex justify-center align-self-stretch mr-3" 
                            style="min-width: 50px"
                            small
                            >
                            {{ auxJuego.name }}
                        </v-chip>
                    </div>
                    <div>
                        <span class="text-overline">{{ juego.tipo_juego.name }}</span>
                    </div>
                </div>
                <div class="d-flex">
                    <v-btn small @click="openDashboard()">ADMINISTRAR</v-btn>
                </div>
            </div>  
            <v-divider class="my-2"/>
            <div>
                <v-chip 
                    v-for="(juegoSorteo, index) of juego.juego_sorteo_list" 
                    :key="`juego-list-item-${juego.id}-sorteo-list-item-${index}-${juegoSorteo.id}`"
                    :outlined="!juegoSorteo.is_active"
                    class="mr-2 mb-2"
                    small
                    label
                    >
                    {{ juegoSorteo.horario }}
                </v-chip>
            </div>
            <v-divider class="mb-2"/>
            <v-chip 
                v-for="(cupoJuego, index) of juego.cupo_juego_list" 
                :key="`juego-list-item-${juego.id}-cupo-list-item-${index}-${cupoJuego.id}`"
                :outlined="!cupoJuego.is_active"
                class="mr-2 mb-2"
                small
                label
                >
                {{ cupoJuego.divisa.name }}
            </v-chip>
        </v-card-text>
        <v-dialog v-model="dashboardOpen">
            <v-card shaped>
                <v-card-title class="primary white--text">
                    <h3>DASHBOARD DE {{ juego.name }}</h3>
                </v-card-title>
                <v-card-text class="pa-3">
                    <Dashboard :juego_id="juego.id" :loteria="juego.loteria">
                        <template v-slot:upper-actions="{ isJuegoLoading }">
                            <v-btn icon primary @click="openModal()" :disabled="isJuegoLoading"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </Dashboard>
                </v-card-text>
            </v-card>
        </v-dialog>
        <ModalJuego :juego="juego" :newG="true" :open.sync="juegoModalOpen" @saved="auxJuego = $event"/>
    </v-card>
</template>
<script>
import ModalJuego from './modal';
import Dashboard from './dashboard';

export default {
    components: {
        ModalJuego,
        Dashboard
    },
    props: {
        juego: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            auxJuego: this.juego,
            dashboardOpen: false,
            juegoModalOpen: false,
            is_active: this.juego.is_active,
        };
    },
    computed: {
    },
    mounted: function () {
    },
    methods: {
        openModal: function () {
            this.juegoModalOpen = true;
        },
        openDashboard: function () {
            this.dashboardOpen = true;
        },
        anulado: function () {
            this.is_active = true;
        },
    },
    watch: {
    },
}
</script>